// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c432e551","463":"f92bc699","691":"ad946062"}[chunkId] + ".chunk.js";
};